import { Component, Input, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS,
  NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { UserAgentService } from '@library/utils/services/user-agent.service';
import { UtilsService } from '@library/utils/services/utils.service';

let lastId = 0;

function UniqueId(prefix = 'time-') {
  lastId++;
  return `${prefix}${lastId}`;
}

@Component({
  selector: 'app-input-time',
  templateUrl: './input-time.component.html',
  styleUrls: ['./input-time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true
    }
  ]
})
export class InputTimeComponent implements ControlValueAccessor, Validator {

  @Input() errors = null;

  formGroupDesktop = new FormGroup({
    hours: new FormControl(null, [
      Validators.required,
      Validators.pattern('(?:[0]?[0-9]|1[0-9]|2[0-3])'),
    ]),
    minutes: new FormControl(null, [
      Validators.required,
      Validators.pattern('(?:[0]?[0-9]|[1-5][0-9])'),
    ]),
  });
  get hours() { return this.formGroupDesktop.get('hours'); }
  get minutes() { return this.formGroupDesktop.get('minutes'); }

  formGroupMobile = new FormGroup({
    time: new FormControl(null, [
      Validators.required,
      Validators.minLength(1),
    ])
  });

  get time() { return this.formGroupMobile.get('time'); }

  uniqueId = UniqueId();

  onChange: any = () => {};
  propogateTouch: any = () => {};

  constructor(
    public userAgent: UserAgentService,
    public utilsService: UtilsService,
  ) { 
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const errors = {} as {invalid: boolean};
    if (this.formGroupDesktop.invalid || this.formGroupMobile.invalid || this.errors) {
      errors.invalid = true;
    }
    return errors;
  }

  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any): void { }

  writeValue(value: number): void {
    if(value !== null){
      const hoursNumber = Math.floor(value / 60);
      const minutesNumber = value % 60;

      const hours = hoursNumber < 10 ? '0' + hoursNumber : hoursNumber.toString();
      const minutes = minutesNumber < 10 ? '0' + minutesNumber : minutesNumber.toString();

      this.formGroupDesktop.setValue({
        hours,
        minutes,
      });

      this.formGroupMobile.setValue({
        time: hours + ':' + minutes,
      });
    }
    
  }

  ngOnInit(): void {
    this.formGroupDesktop.valueChanges.subscribe(value => {
      const hours = parseInt(value.hours, 10);
      const minutes = parseInt(value.minutes, 10);
      this.onChange(minutes + hours * 60);
    });

    this.formGroupMobile.valueChanges.subscribe(value => {
      const [hours, minutes] = this.utilsService.timeToHoursMin(value.time);
      this.onChange(minutes + hours * 60);
    });
  }

}
